// src/pages/Home/styles.ts
import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: url("./home-background.svg") no-repeat 700px bottom;
  background-color: ${(props) => props.theme.tokens.colors.bg};
  display: flex;
  font-family: ${(props) => props.theme.tokens.font.family};

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  font-weight: 900;
  color: ${(props) => props.theme.tokens.colors.ink};
  padding-bottom: 16px;
  text-align: center;

  max-width: 500px;
`;

export const SubTitle = styled.p`
  font-size: 18px;
  color: ${(props) => props.theme.tokens.colors.muted};
  padding-bottom: 32px;
  text-align: center;
  max-width: 500px;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RightContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img.attrs(() => ({
  src: "logo_padrao.png",
}))`
  width: 50%;
`;
